var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromotionsInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "promotions-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.25660676,8.71504318 L12.6290648,2.4461651 C13.4164867,1.67154225 14.6827742,1.68191789 15.457397,2.46933977 C15.461455,2.47346478 15.465495,2.47760739 15.4695171,2.48176747 L21.4959131,8.71504318 L21.4959131,21.8806017 C21.4959131,24.0897407 19.7050521,25.8806017 17.4959131,25.8806017 L10.2566068,25.8806017 C8.04746776,25.8806017 6.25660676,24.0897407 6.25660676,21.8806017 L6.25660676,8.71504318 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promotions-inactive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    transform: "translate(13.876260, 13.876260) rotate(45.000000) translate(-13.876260, -13.876260) ",
    strokeLinejoin: "square"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M7.25660676,9.13406461 L7.25660676,21.8806017 C7.25660676,23.537456 8.59975251,24.8806017 10.2566068,24.8806017 L17.4959131,24.8806017 C19.1527673,24.8806017 20.4959131,23.537456 20.4959131,21.8806017 L20.4959131,9.11940683 L14.7505803,3.176843 C14.7475593,3.17372731 14.7475593,3.17372731 14.7445203,3.17062915 C14.3572089,2.77691821 13.7240652,2.77173039 13.3303542,3.15904182 L7.25660676,9.13406461 Z",
    fillOpacity: 0.15,
    fill: "#2E2B2B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    d: "M6.75660676,8.9245539 L6.75660676,21.8806017 C6.75660676,23.8135984 8.32361013,25.3806017 10.2566068,25.3806017 L17.4959131,25.3806017 C19.4289097,25.3806017 20.9959131,23.8135984 20.9959131,21.8806017 L20.9959131,8.91722501 L15.1100487,2.82930524 C15.1055172,2.8246317 15.1055172,2.8246317 15.1009587,2.81998446 C14.5199915,2.22941805 13.5702759,2.22163632 12.9797095,2.80260346 L6.75660676,8.9245539 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#2E2B2B",
    fill: "#FFFFFF",
    cx: 18.5,
    cy: 9.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.2426407,14.2426407 C32.2426407,12.0335017 30.4517797,10.2426407 28.2426407,10.2426407 C26.0335017,10.2426407 24.2426407,12.0335017 24.2426407,14.2426407",
    id: "Oval-6",
    stroke: "#2E2B2B",
    transform: "translate(28.242641, 12.242641) rotate(-45.000000) translate(-28.242641, -12.242641) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6043366,13.3897936 C36.6043366,11.1806546 34.8134756,9.38979356 32.6043366,9.38979356",
    id: "Oval-6",
    stroke: "#2E2B2B",
    transform: "translate(34.604337, 11.389794) rotate(145.000000) translate(-34.604337, -11.389794) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionsInactive);
export default __webpack_public_path__ + "static/media/promotions-inactive.ebed18624e73c8eaab2086ea728066dc.svg";
export { ForwardRef as ReactComponent };